export const filterDefinedCallback = <T>(item: T | undefined): item is T =>
  item !== undefined;
